<template>
  <div class="flex min-h-screen flex-col">
    <MenuMainMenu />
    <ContainerWideWidth class="flex-1"><slot /></ContainerWideWidth>
    <FooterSiteFooter />
  </div>
</template>
